"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SceneLayoutsLightTheme = void 0;
var _resources = require("../resources");
var gridLightFocus = _resources.resources.gridLightFocus,
  gridLightHover = _resources.resources.gridLightHover,
  gridLightActive = _resources.resources.gridLightActive,
  gridLightDefault = _resources.resources.gridLightDefault,
  gridLightDisabled = _resources.resources.gridLightDisabled,
  sideBySideLightFocus = _resources.resources.sideBySideLightFocus,
  sideBySideLightHover = _resources.resources.sideBySideLightHover,
  sideBySideLightActive = _resources.resources.sideBySideLightActive,
  sideBySideLightDefault = _resources.resources.sideBySideLightDefault,
  sideBySideLightDisabled = _resources.resources.sideBySideLightDisabled,
  featuredPresenterLightFocus = _resources.resources.featuredPresenterLightFocus,
  featuredPresenterLightHover = _resources.resources.featuredPresenterLightHover,
  featuredPresenterLightActive = _resources.resources.featuredPresenterLightActive,
  featuredPresenterLightDefault = _resources.resources.featuredPresenterLightDefault,
  featuredPresenterLightDisabled = _resources.resources.featuredPresenterLightDisabled;

/**
 * In case we want to pass custom css styles
 * to each pseudo-class e.g on hover or focus
 * this can be added under the `styles` prop
 */

var GRID = {
  id: 'GRID',
  title: 'Grid',
  styles: {
    hover: {
      thumbnail: gridLightHover
    },
    focus: {
      thumbnail: gridLightFocus
    },
    active: {
      thumbnail: gridLightActive
    },
    "default": {
      thumbnail: gridLightDefault
    },
    disabled: {
      thumbnail: gridLightDisabled
    }
  }
};
var SIDE_BY_SIDE = {
  id: 'SIDE_BY_SIDE',
  title: 'Side by Side',
  styles: {
    hover: {
      thumbnail: sideBySideLightHover
    },
    focus: {
      thumbnail: sideBySideLightFocus
    },
    active: {
      thumbnail: sideBySideLightActive
    },
    "default": {
      thumbnail: sideBySideLightDefault
    },
    disabled: {
      thumbnail: sideBySideLightDisabled
    }
  }
};
var FEATURED_PRESENTER = {
  id: 'FEATURED_PRESENTER',
  title: 'Featured Presenter',
  styles: {
    hover: {
      thumbnail: featuredPresenterLightHover
    },
    focus: {
      thumbnail: featuredPresenterLightFocus
    },
    active: {
      thumbnail: featuredPresenterLightActive
    },
    "default": {
      thumbnail: featuredPresenterLightDefault
    },
    disabled: {
      thumbnail: featuredPresenterLightDisabled
    }
  }
};
var SceneLayoutsLightTheme = exports.SceneLayoutsLightTheme = [SIDE_BY_SIDE, GRID, FEATURED_PRESENTER];